import {
  AppBar,
  IconButton,
  makeStyles,
  Toolbar,
  Typography
} from '@material-ui/core'
import Button from '../ui/Button'
import useAuth from 'src/hooks/useAuth'
import { FiLogOut } from 'react-icons/fi'

export const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    height: '68px',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 20px',
    background: '#FFF',
    [theme.breakpoints.down('sm')]: {
      padding: '16px'
    }
  },
  logo: {
    height: '50px'
  }
}))

export default function HeaderMfa() {
  const { signOut } = useAuth()
  const classes = useStyles()
  return (
    <AppBar position="static" className={classes.header}>
      <Toolbar variant="dense" title="SYN SAÚDE">
        <img
          src="/image/logo-horizontal.png"
          alt="logo"
          className={classes.logo}
        />
      </Toolbar>

      <Button
        onClick={() => signOut()}
        startIcon={<FiLogOut />}
        variant="contained"
        color="secondary"
      >
        Sair
      </Button>
    </AppBar>
  )
}
